module.exports = __webpack_public_path__ + "static/beet_lex-751c19dac72d2c0170247f88650244e3.jpg";